import { render, staticRenderFns } from "./HighValueReport.vue?vue&type=template&id=1b9b2f0a&scoped=true&"
import script from "./HighValueReport.vue?vue&type=script&lang=ts&"
export * from "./HighValueReport.vue?vue&type=script&lang=ts&"
import style0 from "./HighValueReport.vue?vue&type=style&index=0&id=1b9b2f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b2f0a",
  null
  
)

export default component.exports